import { render, staticRenderFns } from "./ImageImage.vue?vue&type=template&id=fcf12096&scoped=true&"
import script from "./ImageImage.vue?vue&type=script&lang=js&"
export * from "./ImageImage.vue?vue&type=script&lang=js&"
import style0 from "./ImageImage.vue?vue&type=style&index=0&id=fcf12096&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf12096",
  null
  
)

export default component.exports